import type {CodeList} from 'services/codelists/types';
import type {ExpressionImportProps} from 'services/metadata/types';
import {isNullish} from 'schemaDefinition/functions';
import {CodeListRef} from 'schemas/references';
import {isAudioProductForm} from './isAudioProductForm';

export function getRestrictedProductFormCodelistByExpressionFormat(
  {expression: {expressionFormat}}: ExpressionImportProps,
  codelist: CodeList,
): CodeList {
  return isNullish(expressionFormat)
    ? codelist
    : expressionFormat === CodeListRef.EXPRESSION_FORMAT.AUDIO
      ? {
          ...codelist,
          codes: codelist.codes.map(item =>
            isAudioProductForm(item.code) ? item : {...item, disabled: true},
          ),
        }
      : {
          ...codelist,
          codes: codelist.codes.map(item =>
            !isAudioProductForm(item.code) ? item : {...item, disabled: true},
          ),
        };
}
